import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка счетов
    async getInvoices(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start_date", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end_date", serverDate);
      }

      if (data.paid_type > -1) {
        params.set("paid_type", data.paid_type);
      }

      if (data.org_id > 0) {
        params.set("org_id", data.org_id);
      }

      if (data.customer_id > 0) {
        params.set("customer_id", data.customer_id);
      }

      return await this.get(`invoices?${params.toString()}${sorting}`);
    },
    // Получение счёта
    async getInvoiceById(id) {
      return await this.get(`invoices/id/${id}`);
    },
    // Создание счёта
    async postInvoice(data) {
      return await this.post('invoices', data);
    },
    // Изменение счёта
    async putInvoice(data) {
      return await this.put(`invoices/${data.id}`, data);
    },
    // Удаление заказчика
    async deleteInvoice(data) {
      return await this.delete(`invoices/${data.id}`, null);
    },
    async getInvoiceFile(data) {
      return await this.getFile(`invoices/${data.id}/document/${data.exportType}?hasStamp=${data.hasStamp}`);
    },
    async getInvoiceActFile(data) {
      return await this.getFile(`invoices/${data.id}/act/${data.exportType}?hasStamp=${data.hasStamp}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/network/invoices.js